import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-department-dialog-box',
  templateUrl: './department-dialog-box.component.html',
  styleUrls: ['./department-dialog-box.component.scss']
})
export class DepartmentDialogBoxComponent implements OnInit {
DepartmentForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  DepartmentList: any;
  Department: string;
  isread = false;
  isreaddelete = false;
  APIService: any;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  DepartmentCreate=true;
  DepartmentUpdate=true;
  DepartmentDelete=true;
  userPermission: any;
  utp: string;
  fcCodeList: any;
  filteredListFcCode: any;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService,
   private dialogRef2:MatDialogRef<DepartmentDialogBoxComponent>,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      this.userPermission.forEach(element => {
      if(element.PageName == 'Department' && element.PCreate == false)
      {
          this.DepartmentCreate = false;  
      }
      if(element.PageName == 'Department' && element.PUpdate == false)
      {
          this.DepartmentUpdate = false;  
      }   
      if(element.PageName == 'Department' && element.PDelete == false)
      {
          this.DepartmentDelete = false;  
      } 
    });
  }
    window.scroll(0, 0);
    this.submitButton = true;
    this.editButton = false;
    this.getDepartmentData();
    this.DepartmentForm = this.fb.group({
      DeptCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
      DeptName: new FormControl ('', [Validators.required]),
      FcCode: new FormControl ('', [Validators.required]),
    });

    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
    this.prepopulationForDelete(this.data.selected);
    } else {
      
    }
    this.fetchFacultyCode();
  }

  getDepartmentData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDeptData(payload).subscribe(res => {
      if(res.status){
        this.DepartmentList = res.data;
        this.spinner.hide();
      }else{
        this.spinner.hide();
      }
      
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.DepartmentList = [];
       
     });
  }

  prepopulation(id) {
    this.spinner.show();
    const payload = {};
    payload['DeptCode'] = id.DeptCode;
    this.umsService.getDeptData(payload).subscribe((res) => {
      this.spinner.hide();
      const data = res.data[0];
      if (res.status){
         this.editButton = true;
         this.isreaddelete = false;
         this.submitButton = false;
         this.isread = true;
         this.deleteButton  = false;
         this.DepartmentForm = this.fb.group({
          DeptCode: new FormControl (data.DeptCode, [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
          DeptName: new FormControl (data.DeptName, [Validators.required]),
          FcCode: new FormControl (data.FcCode, [Validators.required]),
        });
       }else{
         
       }
     });
  }

  prepopulationForDelete(id){
    this.spinner.show();
    const payload = {};
    payload['DeptCode'] = id.DeptCode;
    payload['DeptName'] = id.DeptName;
    this.umsService.getDeptData(payload).subscribe((res) => {
      this.spinner.hide();
      const data = res.data[0];
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        this.isreaddelete = true;
        this.deleteButton = true;
        this.DepartmentForm = this.fb.group({
          DeptCode: new FormControl (data.DeptCode, [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
          DeptName: new FormControl (data.DeptName, [Validators.required]),
          FcCode: new FormControl (data.FcCode, [Validators.required]),
        });
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
        });

      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });
      
   });
  }

  DeletetheRecord(){
    const  data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes'){
        this.deletedata(this.DepartmentForm.value);
        this.dialogRef2.close();
      }else{
        this.dialogRef2.close();
      }
    });
   }
   deletedata(id){
    this.spinner.show();
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
      DeptCode: id.DeptCode,
      DeptName: id.DeptName,
      FcCode: id.FcCode
    },
  };
    this.httpClient.delete(this.APIService + '/masters/DeleteDepartment', options)
    .subscribe((s) => {
      this.spinner.hide();
      let cc = [];
      cc.push(s);
      let  data = {}
      data['message'] = cc[0].message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });
   });

   }

  submit(){
    if (this.DepartmentForm.invalid) {
      this.DepartmentForm.get('DeptCode').markAsTouched();
      this.DepartmentForm.get('DeptName').markAsTouched();
      this.DepartmentForm.get('FcCode').markAsTouched();
      return;
    } else {
      this.ADDDepartment();
    }
  }

  ADDDepartment() {
    this.spinner.show();
    this.submitpayload = this.DepartmentForm.value;
    this.umsService.addDepartment(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      
    });
  }

  update(){
    if (this.DepartmentForm.invalid) {
      this.DepartmentForm.get('DeptCode').markAsTouched();
      this.DepartmentForm.get('DeptName').markAsTouched();
      this.DepartmentForm.get('FcCode').markAsTouched();
      return;
    } else {
      this.UpdateDepartment();
    }
  }

  UpdateDepartment() {
    this.spinner.show();
    this.submitpayload = this.DepartmentForm.value;
    this.umsService.updateDepartment(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {} 
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    });
  }


  
  fetchFacultyCode() {
    this.spinner.show()
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
} 

